import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim grounded in EAKC-MVP: src/app/api/mcp/route.ts + src/lib/mcp/tools.ts +
// src/lib/rag/{query-expander,query-rewriter,query-decomposer,retrieval,reranker}.ts.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "\"MCP is dead. CLI won.\" I shipped an MCP server anyway — because that take is answering the wrong question." },
];

export const STEELMAN: ScriptLine[] = [
  { scene: "steelman", fromSec: 0.4, holdSec: 6, caption: "Let me steelman it first. The critics are partly right." },
  { scene: "steelman", fromSec: 6.4, holdSec: 5.5, caption: "Tool schemas add tokens. Auth adds friction. Agents already live in the terminal." },
  { scene: "steelman", fromSec: 12.2, holdSec: 5.5, caption: "All true — but only as a critique of MCP used as INTERNAL plumbing. That's not what it's for." },
];

export const INTERNAL: ScriptLine[] = [
  { scene: "internal", fromSec: 0.4, holdSec: 6, caption: "Inside EAKC, my RAG pipeline uses zero MCP. None." },
  { scene: "internal", fromSec: 6.6, holdSec: 5.5, caption: "Expand, rewrite, decompose, hybrid search, rerank — all direct TypeScript imports." },
  { scene: "internal", fromSec: 12.4, holdSec: 3.5, caption: "MCP between your own services is HTTP to call a function in the same file." },
];

export const WHY: ScriptLine[] = [
  { scene: "why", fromSec: 0.4, holdSec: 6, caption: "But EAKC also ships an MCP server. Here's why CLI can't replace it." },
  { scene: "why", fromSec: 6.6, holdSec: 6, caption: "It's a shared product surface: Claude Desktop, Cursor, any agent can query the knowledge base." },
  { scene: "why", fromSec: 12.8, holdSec: 4.5, caption: "The thing CLI can't give you for free: standardized discovery." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, holdSec: 6.5, caption: "It's a real JSON-RPC server at POST /api/mcp. tools/list hands back the schema." },
  { scene: "code", fromSec: 7.2, holdSec: 6.5, caption: "X-API-Key resolves to a tenant. Every tool enforces tenant isolation. 60 requests a minute." },
  { scene: "code", fromSec: 14, holdSec: 6.5, caption: "One contract. Any client connects without me writing a custom integration for each." },
];

export const CONTEXT: ScriptLine[] = [
  { scene: "context", fromSec: 0.4, holdSec: 6, caption: "\"But tool definitions bloat the context window.\" Put it in proportion." },
  { scene: "context", fromSec: 6.6, holdSec: 6.5, caption: "A few tool schemas are kilobytes against a million-token window. That's a config choice, not a protocol flaw." },
  { scene: "context", fromSec: 13.4, holdSec: 2.5, caption: "Give an agent 50 CLI commands and it still has to know all 50." },
];

export const LAYERS: ScriptLine[] = [
  { scene: "layers", fromSec: 0.4, holdSec: 6, caption: "It was never MCP versus CLI. It's three different layers." },
  { scene: "layers", fromSec: 6.6, holdSec: 6, caption: "Internal: direct calls. Dev tooling: CLI. External agents: a protocol." },
  { scene: "layers", fromSec: 12.8, holdSec: 3.5, caption: "The hot take compares the dev layer with the external layer and crowns a winner." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, holdSec: 5, caption: "Don't rip out your MCP server because a viral video told you to. Ask who's calling your system." },
  { scene: "outro", fromSec: 5.8, holdSec: 4.2, caption: "Next: five production bugs that almost killed the project — and their one-line fixes." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
